import React from 'react';

import type { ImageSizes } from '../../helpers/images';
import BannerShell from './BannerShell';
import type { BannerAnalytics, BannerLayout, StoryblokBannerV3 } from './types';

type Props = {
  banner: StoryblokBannerV3;
  layout: BannerLayout;
  className?: string;
  imageSizes: ImageSizes;
  analytics: BannerAnalytics;
};

const BannerLink: React.FC<Props> = ({
  analytics,
  banner,
  className,
  imageSizes,
  layout,
}) => {
  return (
    <BannerShell
      analytics={analytics}
      category={useBannerCategory(banner)}
      className={className}
      description={useBannerDescription(banner)}
      headline={useBannerHeadline(banner)}
      href={useBannerHref(banner)}
      images={useBannerImages(banner)}
      imageSizes={imageSizes}
      isExternal
      labels={useBannerLabels(banner)}
      layout={layout}
      video={useBannerVideo(banner)}
    />
  );
};

export default BannerLink;

export const useBannerHref = (banner: StoryblokBannerV3): string => {
  return banner.link.url;
};

export const useBannerVideo = (banner: StoryblokBannerV3) => {
  return banner.overrideVideo?.vimeo_oembed ? banner.overrideVideo : undefined;
};

export const useBannerImages = (
  banner: StoryblokBannerV3,
): StoryblokImage[] => {
  return banner.overrideImages?.slice(0, 3) || [];
};

export const useBannerCategory = (banner: StoryblokBannerV3): string => {
  return banner.overrideCategory || '';
};

export const useBannerHeadline = (banner: StoryblokBannerV3): string => {
  return banner.overrideHeadline || '';
};

export const useBannerDescription = (
  banner: StoryblokBannerV3,
): StoryblokTextAreaType => {
  return banner.overrideDescription || '';
};

export const useBannerLabels = (banner: StoryblokBannerV3) => {
  return banner.overrideLabel
    ? [{ active: false, loading: false, text: banner.overrideLabel }]
    : [];
};
